export default __webpack_public_path__ + "static/banner-15-money-management-hacks-0778233e2f35aadc66856c99e762f3bd.jpg";